/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, useEffect } from "react";
import {
  Route,
  Navigate,
  useLocation,
  Routes,
  NavLink,
  useNavigate,
} from "react-router-dom";
import Draggable from "react-draggable";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import CancelPresentationOutlinedIcon from "@mui/icons-material/CancelPresentationOutlined";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Typography,
  Divider,
  Skeleton,
} from "@mui/material";
// import AccountBoxOutlinedIcon from "@mui/icons-material/AccountBoxOutlined";
// import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWorkOutlined";
// import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
// import TextSnippetOutlinedIcon from "@mui/icons-material/TextSnippetOutlined";
// import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import "./App.css";
import Header from "./components/HeaderMenu";
import LoginPage from "./Auth/Login";
import ProtectedRoute from "./Utils/ProtectedRoute";
import EmployerPage from "./pages/EmployerPages/EmployerPages";
// import PersonSearchOutlinedIcon from "@mui/icons-material/PersonSearchOutlined";
// import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
// import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
// import CloudSyncOutlinedIcon from "@mui/icons-material/CloudSyncOutlined";
import BlogList from "./pages/Blogs/BlogListMenu";
import BlogDisplay from "./pages/Blogs/BlogsDisplay";
import RichTextEditor from "./pages/Blogs/RichTextEditors";
import Jobs from "./pages/JobsPages/JobsPages";
import Candidates from "./pages/CandidatesPages/CandidatesPages";
import Users from "./pages/UsersPages/UserPages";
import EmployerDescription from "./pages/EmployerPages/EmployerDescriptions";
import EmployerDashboard from "./pages/DashboardPages/EmployersDashboard";
import Logout from "./Auth/LogoutHandler";
import Companies from "./pages/CompaniesPages/CompaniesPages";
import CandidateDescription from "./pages/CandidatesPages/CandidateDescription";
import CompanyDescription from "./pages/CompaniesPages/CompanyDetails";
import BranchDetails from "./pages/CompaniesPages/BranchDetails";
import UserDetails from "./pages/UsersPages/UserDetails";
import JobDescription from "./pages/JobsPages/JobDescription";
import Logs from "./pages/Logs/Logs";
import Backup from "./pages/backup/Backup";
import API from "./Utils/Interceptor/ApiMiddleware";
import AddedCandidates from "./pages/CandidatesPages/AddedCandidates";
const dimensions = {
  headerHeight: 64,
  drawerWidth: {
    open: 250,
    closed: 100,
  },
};

const Sidebar = React.memo(({ open, toggleSidebar }) => {
  const location = useLocation();

  const menuItems = useMemo(
    () => [
      {
        text: "Dashboard",
        // icon: <TrendingUpOutlinedIcon />,
        icon: (
          <img
            src="/Dashboard_img.svg"
            alt="dashboard"
            style={{ width: 18, height: 18 }}
          />
        ),
        route: "/dashboard",
      },
      {
        text: "Employer",
        // icon: <AccountBoxOutlinedIcon />,
        icon: (
          <img
            src="/Employer_img.svg"
            alt="employer"
            style={{ width: 18, height: 18 }}
          />
        ),
        route: "/employer?page=1",
      },
      {
        text: "Companies",
        icon: (
          <img
            src="/Company_img.svg"
            alt="Company"
            style={{ width: 18, height: 18 }}
          />
        ),
        // icon: <HomeWorkOutlinedIcon />,
        route: "/companies?page=1",
      },
      {
        text: "Jobs",
        icon: (
          <img
            src="/Jobs_img.svg"
            alt="jobs"
            style={{ width: 18, height: 18 }}
          />
        ),
        // icon: <WorkOutlineOutlinedIcon />,
        route: "/jobs?page=1",
      },
      {
        text: "Candidates",
        icon: (
          <img
            src="/Candidates_img.svg"
            alt="candidates"
            style={{ width: 18, height: 18 }}
          />
        ),
        // icon: <Groups2OutlinedIcon />,
        route: "/candidates?page=1",
      },
      {
        text: "Users",
        icon: (
          <img
            src="/Users_img.svg"
            alt="users"
            style={{ width: 18, height: 18 }}
          />
        ),
        // icon: <PersonSearchOutlinedIcon />,
        route: "/users?page=1",
      },
      {
        text: "Blogs",
        icon: (
          <img
            src="/Blogs_img.svg"
            alt="blogs"
            style={{ width: 18, height: 18 }}
          />
        ),
        // icon: <EditNoteOutlinedIcon />,
        route: "/blogs",
      },
      {
        text: "Logs",
        icon: (
          <img
            src="/Logs_img.svg"
            alt="logs"
            style={{ width: 18, height: 18 }}
          />
        ),
        // icon: <TextSnippetOutlinedIcon />,
        route: "/logs?page=1",
      },
      {
        text: "Backup",
        icon: (
          <img
            src="/Backup_img.svg"
            alt="backup"
            style={{ width: 18, height: 18 }}
          />
        ),
        // icon: <CloudSyncOutlinedIcon />,
        route: "/backup",
      },
    ],
    []
  );

  // const containerRef = useRef();

  // useEffect(() => {
  //   if (containerRef.current) {
  //     containerRef.current.scrollTo(0, 0);
  //   }
  //   window.scrollTo(0, 0);
  //   console.clear();
  //   console.error = () => {}; // Override to do nothing
  //   console.warn = () => {}; // Override to do nothing
  //   console.log = () => {}; // Override to do nothing
  //   console.info = () => {}; // Override to do nothing
  // }, [location.pathname, location.search]);

  return (
    <Drawer
      sx={{
        width: open
          ? dimensions.drawerWidth.open
          : dimensions.drawerWidth.closed,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: open
            ? dimensions.drawerWidth.open
            : dimensions.drawerWidth.closed,
          boxSizing: "border-box",
          transition: "width 0.5s",
          border: "none",
          overflow: "hidden !important",
          padding: "30px 20px",
        },
        overflow: "hidden !important",
      }}
      variant="permanent"
      anchor="left"
      open={open}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          padding: "0px 16px",
          justifyContent: "center",
          height: dimensions.headerHeight,
        }}
      >
        <IconButton
          onClick={() => toggleSidebar()}
          disableRipple
          sx={{
            backgroundColor: "transparent !important",
            "&:hover": {
              backgroundColor: "transparent !important",
            },
          }}
        >
          {open ? (
            <img
              src="https://jobeze.com/logo/SiteAdminLogo.svg"
              style={{ height: "42px" }}
              alt="Logo"
            />
          ) : (
            <img
              src="../smLogoVector.png"
              style={{ height: "23px" }}
              alt="Logo"
            />
          )}
        </IconButton>
      </Box>
      <List
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "6px",
          height: "100%",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {menuItems.map((item, index) => (
          <ListItem
            button
            key={index}
            component={NavLink}
            to={item.route}
            href={item.route}
            selected={
              (item.route.split("?")[0] === "/companies" &&
                (location.pathname.startsWith("/companies") ||
                  location.pathname.startsWith("/branch-details"))) ||
              location.pathname.startsWith(item.route.split("?")[0])
            }
            sx={{
              backgroundColor:
                (item.route.split("?")[0] === "/companies" &&
                  (location.pathname.startsWith("/companies") ||
                    location.pathname.startsWith("/branch-details"))) ||
                location.pathname.startsWith(item.route.split("?")[0])
                  ? "#3F95EA"
                  : "transparent",
              color:
                (item.route.split("?")[0] === "/companies" &&
                  (location.pathname.startsWith("/companies") ||
                    location.pathname.startsWith("/branch-details"))) ||
                location.pathname.startsWith(item.route.split("?")[0])
                  ? "white"
                  : "gray",
              "&:hover": {
                backgroundColor:
                  (item.route.split("?")[0] === "/companies" &&
                    (location.pathname.startsWith("/companies") ||
                      location.pathname.startsWith("/branch-details"))) ||
                  location.pathname.startsWith(item.route.split("?")[0])
                    ? "#3F95EA"
                    : "#F5F5F5",
              },
              padding: "16px 20px",
              borderRadius: "8px",
              fontSize: "14px",
            }}
          >
            <Box
              component="img"
              src={item.icon.props.src}
              alt={item.text}
              sx={{
                width: 18,
                height: 18,
                filter:
                  (item.route.split("?")[0] === "/companies" &&
                    (location.pathname.startsWith("/companies") ||
                      location.pathname.startsWith("/branch-details"))) ||
                  location.pathname.startsWith(item.route.split("?")[0])
                    ? "brightness(0) invert(1)"
                    : "none",
              }}
            />
            {open && (
              <ListItemText
                primary={item.text}
                sx={{
                  marginLeft: "12px",
                  fontSize: "14px !important",
                  "& .css-rizt0-MuiTypography-root ": {
                    fontSize: "14px !important",
                  },
                }}
              />
            )}
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
});

const isAuthenticated = () => {
  const storedAuthState = localStorage.getItem("authState");
  if (storedAuthState) {
    return true;
  }
  return false;
};

const App = () => {
  const [open, setOpen] = useState(true);
  const location = useLocation();
  const toggleSidebar = () => {
    setOpen(!open);
  };
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadingFiles, setUploadingFiles] = useState([]);
  const [processedFiles, setProcessedFiles] = useState([]);
  const [uploadPanelOpen, setUploadPanelOpen] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const navigation = useNavigate();

  const pollStatus = (jobId) => {
    localStorage.setItem("bulkUploadJobId", jobId);
    setIsProcessing(true);
    const intervalId = setInterval(async () => {
      try {
        const { data } = await API.get(`/candidate/status/${jobId}`);

        const { total, processed } = data.data;
        setUploadProgress(processed);
        setProcessedFiles(data.data.processedFiles);
        console.log(`Progress: ${processed}/${total}`);

        if (parseInt(total) === parseInt(processed)) {
          clearInterval(intervalId);
          setIsProcessing(false);
          setTimeout(() => {
            const currentUrl = window.location.href;
            if (currentUrl.includes("/candidates")) {
              window.dispatchEvent(new CustomEvent("bulkUploadComplete"));
            }
          }, 1500);
          console.log("Processing complete!");
        }
      } catch (err) {
        console.error("Error polling status:", err);
        clearInterval(intervalId);
        setIsProcessing(false);
      }
    }, 10000);
  };

  useEffect(() => {
    const storedJobId = localStorage.getItem("bulkUploadJobId");
    if (storedJobId) {
      setUploadPanelOpen(true);
      setIsProcessing(true);

      const savedFiles = JSON.parse(
        localStorage.getItem("bulkUploadFiles") || "[]"
      );
      if (savedFiles.length) {
        setUploadingFiles(
          savedFiles.map((name) => ({ file: { name }, selected: true }))
        );
      }
      pollStatus(storedJobId);
    }
  }, []);

  const handleOpenDetails = () => {
    navigation("/added-candidates");
  };

  const isLoginPage = location.pathname === "/login";

  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      {!isLoginPage && <Sidebar open={open} toggleSidebar={toggleSidebar} />}
      <Box
        sx={{
          flexGrow: 1,
          transition: "margin-left 0.5s",
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {!isLoginPage && (
          <Header
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 1000,
              backgroundColor: "white",
            }}
          />
        )}
        <Box sx={{ flexGrow: 1, overflow: "auto" }}>
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />

            <Route
              path="/login"
              element={
                isAuthenticated() ? (
                  <Navigate to="/dashboard" replace />
                ) : (
                  <LoginPage />
                )
              }
            />

            <Route
              path="/dashboard"
              element={<ProtectedRoute element={<EmployerDashboard />} />}
            />
            <Route
              path="/jobs"
              element={<ProtectedRoute element={<Jobs />} />}
            />
            <Route
              path="/candidates"
              element={
                <ProtectedRoute
                  element={
                    <Candidates
                      pollStatus={pollStatus}
                      setUploadProgress={setUploadProgress}
                      setUploadingFiles={setUploadingFiles}
                      setUploadPanelOpen={setUploadPanelOpen}
                      setProcessedFiles={setProcessedFiles}
                      isProcessing={isProcessing}
                      setIsProcessing={setIsProcessing}
                    />
                  }
                />
              }
            />
            <Route
              path="/added-candidates"
              element={
                <ProtectedRoute
                  element={
                    <AddedCandidates
                      processedFiles={processedFiles}
                      isProcessing={isProcessing}
                    />
                  }
                />
              }
            />
            <Route
              path="/employer"
              element={<ProtectedRoute element={<EmployerPage />} />}
            />
            <Route
              path="/blogs"
              element={<ProtectedRoute element={<BlogList />} />}
            />
            <Route
              path="/blogs/details/:id"
              element={<ProtectedRoute element={<BlogDisplay />} />}
            />
            <Route
              path="/blogs/create"
              element={<ProtectedRoute element={<RichTextEditor />} />}
            />
            <Route
              path="/blogs/:id/edit"
              element={<ProtectedRoute element={<RichTextEditor />} />}
            />
            <Route path="/logout" element={<Logout />} />
            <Route
              path="/companies"
              element={<ProtectedRoute element={<Companies />} />}
            />
            <Route
              path="/jobs"
              element={<ProtectedRoute element={<Jobs />} />}
            />
            <Route
              path="/users"
              element={<ProtectedRoute element={<Users />} />}
            />
            <Route
              path="/employer-description/:id"
              element={<ProtectedRoute element={<EmployerDescription />} />}
            />
            <Route
              path="/companies-description/:id"
              element={<ProtectedRoute element={<CompanyDescription />} />}
            />
            <Route
              path="/branch-details/:id"
              element={<ProtectedRoute element={<BranchDetails />} />}
            />
            <Route
              path="/candidates-description/:id"
              element={<ProtectedRoute element={<CandidateDescription />} />}
            />
            <Route
              path="/users-details/:id"
              element={<ProtectedRoute element={<UserDetails />} />}
            />
            <Route
              path="/jobs-description/:id"
              element={<ProtectedRoute element={<JobDescription />} />}
            />
            <Route
              path="/logs"
              element={<ProtectedRoute element={<Logs />} />}
            />
            <Route
              path="/backup"
              element={<ProtectedRoute element={<Backup />} />}
            />
          </Routes>
        </Box>
      </Box>
      {uploadPanelOpen && (
        <Draggable handle=".upload-drag-handle" bounds="body">
          <Box
            sx={{
              position: "fixed",
              bottom: 20,
              right: 20,
              width: 480,
              zIndex: 1300,
              bgcolor: "white",
              borderRadius: 2,
              boxShadow: 3,
            }}
          >
            <Box
              className="upload-drag-handle"
              sx={{
                cursor: "move",
                p: "10px 20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography fontWeight="500">Adding Bulk Candidates</Typography>
              {uploadProgress >= uploadingFiles.length ? (
                <IconButton
                  onClick={() => {
                    setUploadPanelOpen(false);
                    localStorage.removeItem("bulkUploadJobId");
                  }}
                >
                  <CloseIcon />
                </IconButton>
              ) : (
                <OpenInNewOutlinedIcon
                  sx={{
                    border: "1px solid #D9EAFB",
                    borderRadius: "8px",
                    padding: "6px",
                    fontSize: "28px",
                    color: "#1A1A1A",
                    cursor: "pointer",
                  }}
                  onClick={handleOpenDetails}
                />
              )}
            </Box>
            <Divider />

            {uploadProgress < uploadingFiles.length ? (
              <>
                <Box p={"20px 20px 0px 20px"}>
                  {processedFiles.slice(0, 2).map((file, index) => (
                    <Box key={index} mb={2}>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        gap={2}
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={2}
                          flex={1}
                        >
                          {file.status === "successful" ? (
                            <TaskOutlinedIcon
                              sx={{
                                color: "#4CAF50",
                                border: "1px solid #3F95EA33",
                                borderRadius: "8px",
                                padding: "8px",
                                fontSize: "38px",
                              }}
                            />
                          ) : (
                            <CancelPresentationOutlinedIcon
                              sx={{
                                color: "#E25C72",
                                border: "1px solid #3F95EA33",
                                borderRadius: "8px",
                                padding: "8px",
                                fontSize: "38px",
                              }}
                            />
                          )}

                          <Box>
                            <Typography
                              variant="body1"
                              color="text.primary"
                              fontWeight="bold"
                              fontSize={18}
                              noWrap
                              sx={{ maxWidth: 220 }}
                            >
                              {file.fileName}
                            </Typography>
                            <Typography
                              color={
                                file.status === "successful"
                                  ? "text.secondary"
                                  : "error"
                              }
                              size={14}
                            >
                              {file.fileSize < 1024 * 1024
                                ? `${(file.fileSize / 1024).toFixed(2)} KB`
                                : `${(file.fileSize / (1024 * 1024)).toFixed(
                                    2
                                  )} MB`}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </Box>
                <Divider />
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  p={2.5}
                >
                  <Skeleton variant="circular" width={40} height={40} />
                  <Box sx={{ flex: 1, ml: 2 }}>
                    <Skeleton variant="text" width="60%" height={20} />
                    <Skeleton variant="text" width="40%" height={20} />
                  </Box>
                </Box>
                <Divider />
                <Box display="flex" flexDirection="column" p={"10px 20px"}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Box
                      sx={{
                        flexGrow: 1,
                        height: 5,
                        backgroundColor: "#e0e0e0",
                        borderRadius: 5,
                        overflow: "hidden",
                      }}
                    >
                      <Box
                        sx={{
                          width: `${
                            (uploadProgress / uploadingFiles.length) * 100
                          }%`,
                          backgroundColor: "#3f95ea",
                          height: "100%",
                        }}
                      />
                    </Box>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      minWidth={30}
                    >
                      {Math.round(
                        (uploadProgress / uploadingFiles.length) * 100
                      )}
                      %
                    </Typography>
                  </Box>
                  <Typography fontSize={14}>
                    {uploadProgress}/{uploadingFiles.length} Candidates
                    Processed
                  </Typography>
                </Box>
              </>
            ) : (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                p={2}
              >
                <Box display="flex" alignItems="center" gap={2}>
                  <CheckCircleOutlineOutlinedIcon
                    sx={{ color: "#4CAF50", fontSize: 50 }}
                  />
                  <Box>
                    <Typography sx={{ fontSize: "18px", fontWeight: "500" }}>
                      Candidates Processed Successfully!
                    </Typography>
                    <Typography fontSize={14} color="text.secondary">
                      {uploadingFiles.length}/{uploadingFiles.length}
                    </Typography>
                  </Box>
                </Box>
                <IconButton>
                  <OpenInNewOutlinedIcon
                    sx={{
                      border: "1px solid #D9EAFB",
                      borderRadius: "8px",
                      padding: "6px",
                      fontSize: "32px",
                      color: "#1A1A1A",
                    }}
                    onClick={handleOpenDetails}
                  />
                </IconButton>
              </Box>
            )}
          </Box>
        </Draggable>
      )}
    </Box>
  );
};

export default App;
